/**
 * Created by adam on 9/4/17.
 */


if (window.jQuery) {
  jQuery( function ( $ ) {

    function shouldRunTest() {
      return true;
    }

    var isArticle = $( 'main.article' ),
      isSponsored = $( 'main.sponsored' );
    //check if this article page and not sponsored one
    if (shouldRunTest && isArticle.length && isSponsored.length === 0) {
      var afterFirstParagraph = $( '.after-first-paragraph' ),
        endOfContent = $( '#end-of-content' );

      TCT.Testing.getTestData( 990, null ).then( function ( data ) {
        TCT.debug( 'Test data:', data );
        if (data && data.variant) { // for extra safety
          var brandBannerInstruction = data.instruction;

          if (brandBannerInstruction) {
            var brandBannerJson = JSON.parse( brandBannerInstruction ),
              middleBanner = '<div onclick=trackCTA("middle_brand_banner_click"); style="width:284px;height:210px;margin:auto;">' +
                '<img src=' + brandBannerJson.middleBanner + ' />' +
                '<div id="middle-brand-banner-view" style="width:1px;height:1px"></div>' +
                '</div>',

              endOfContentBanner = '<div onclick=trackCTA("end_of_content_brand_banner_click"); style="width:284px;height:130px;margin:auto;">' +
                '<img src=' + brandBannerJson.endBanner + ' />' +
                '<div id="end-of-content-brand-banner-view" style="width:1px;height:1px"></div>' +
                '</div>';

            afterFirstParagraph.append( middleBanner );
            endOfContent.append( endOfContentBanner );
            var middleBannerDiv = $( '#middle-brand-banner-view' ),
              endBannerDiv = $( '#end-of-content-brand-banner-view' );

            if (middleBannerDiv.length) {
              middleBannerDiv.one( 'inview', function reached() {
                trackCTA( 'middle_banner_in_view' );
              } );
            }
            if (endBannerDiv.length) {
              endBannerDiv.one( 'inview', function reached() {
                trackCTA( 'end_of_content_banner_in_view' );
              } );
            }
          }


        }
        else {
          $( 'body' ).trigger( 'tct-ad-slots-show-ads' );
        }
      },
        function() {
          $( 'body' ).trigger( 'tct-ad-slots-show-ads' );
      } )

    }
    else {
      $( 'body' ).trigger( 'tct-ad-slots-show-ads' );
    }
  } );
}